var getValueAsString = function getValueAsString(value, _ref) {
  var valueAccessor = _ref.valueAccessor;

  if (typeof value === 'string') {
    return valueAccessor(value);
  }

  if (value instanceof Array) {
    return value.map(function (item) {
      return valueAccessor(item);
    }).join(',');
  }
};

export default getValueAsString;